import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'pillar',
    label: i18n('entities.issues.fields.pillar'),
    schema: schemas.string(
      i18n('entities.issues.fields.pillar'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'topic',
    label: i18n('entities.issues.fields.topic'),
    schema: schemas.string(
      i18n('entities.issues.fields.topic'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'issue',
    label: i18n('entities.issues.fields.issue'),
    schema: schemas.string(
      i18n('entities.issues.fields.issue'),
      {
        "required": true
      },
    ),
  },
];